module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
   var description = '';
   var nameP = 'Page 1';
   if(currentPage){
      description = currentPage._description ? currentPage._description : '';
      nameP = currentPage._name ? currentPage._name : 'Page 1';
   }

    ; __append("\r\n<!-- 3 column layout -->\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <div class=\"col-sm-8\">\r\n                <h1>")
    ; __append(escapeFn(dashboardTitle))
    ; __append("</h1>\r\n            </div>\r\n            <div class=\"col-sm-4 \" >\r\n                <button id=\"importLibrary\" class=\"btn btn-primary hvr-glow\" style=\"float:right\">Import</button>\r\n            </div>\r\n        </div>\r\n    </div> \r\n     \r\n     <ol class=\"breadcrumb\">\r\n        <li><a href=\"#\" id=\"goToForms\">Apps</a></li>\r\n        <li><a href=\"#\" id=\"goToLibraries\">Library</a></li>\r\n        <li class=\"active\"> ")
    ; __append(escapeFn( name ))
    ; __append("</li>\r\n    </ol>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-sm-12 col-lg-4\">\r\n        <div class=\"block\">\r\n            <h2>Assets</h2>\r\n            <div class=\"row nopadding\">\r\n                <div class=\"col-sm-6\">\r\n                 <p>\r\n                     ")
    ; __append(escapeFn( libraryData._description ))
    ; __append("\r\n                 </p>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col col-sm-12 col-lg-4\">\r\n        <div class=\"block\">\r\n            <h2>General</h2>\r\n            <div class=\"row nopadding\">\r\n                <div class=\"col-sm-6\" id=\"imagesSection\">\r\n                   ")
    ; if(images[0]){
                        _.forEach(images, function(image, index){
                           if(libraryData.Assets.Asset instanceof Array){
    ; __append("\r\n                             <img src=\"")
    ; __append( image )
    ; __append("\" id=\"")
    ; __append(escapeFn(libraryData.Assets.Asset[index]._internalId))
    ; __append("\">\r\n                          ")
    ; }else{
    ; __append("\r\n                             <img src=\"")
    ; __append( image )
    ; __append("\" id=\"")
    ; __append(escapeFn(libraryData.Assets.Asset._internalId))
    ; __append("\">\r\n                          ")
    ; }
                        })
                    }
                    
    ; __append("\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col col-sm-12\">\r\n        <h1>")
    ; __append(escapeFn(nameP))
    ; __append("</h1>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-sm-12 col-lg-4\">\r\n        <p>\r\n            ")
    ; __append(escapeFn(description))
    ; __append("\r\n        </p>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}